import Banner from "@/components/Home/Banner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/shared/Footer";

const Home = () => {
	return (
		<>
			<Navbar />
			<Banner />
			<Footer />
		</>
	);
};

export default Home;
